import { render, staticRenderFns } from "./TaskListOrderExportPop.vue?vue&type=template&id=20059496&"
import script from "./TaskListOrderExportPop.vue?vue&type=script&lang=js&"
export * from "./TaskListOrderExportPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports